var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMultiUnit = function SvgMultiUnit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 39 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.094 21.132V6.258h20.614v15.117m0 9.028v4.963H9.094v-5.034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.262 35.368V24.28h10.283v11.087"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M19.402 23.945v11.717"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.379 21.53h3.343v-4.956h-3.343v4.956zm0-7.157h3.343V9.418h-3.343v4.955zm6.824 7.157h3.343v-4.956h-3.343v4.956zm0-7.157h3.343V9.418h-3.343v4.955z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.2 38.023v-2.656h22.405v2.656M9.098 6.258V3.602h20.61v2.656M13.05 3.435V1h2.657v2.435M33.379 25.41v12.273m1.827-10.913-1.839 1.91m-1.539-2.547 1.449 1.25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.945 24.622a3.964 3.964 0 0 0-1.345-5.026c.08-.236.132-.484.132-.746a2.354 2.354 0 0 0-4.707 0c0 .262.054.51.133.746a3.964 3.964 0 0 0-1.345 5.026 4.463 4.463 0 0 0-.918 2.713 4.484 4.484 0 1 0 8.969 0 4.46 4.46 0 0 0-.92-2.713z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.484 25.406V37.68M3.656 26.77l1.84 1.91m1.539-2.547-1.45 1.25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.919 24.622a3.964 3.964 0 0 1 1.345-5.026 2.336 2.336 0 0 1-.133-.746 2.354 2.354 0 1 1 4.707 0c0 .262-.053.51-.132.746a3.964 3.964 0 0 1 1.344 5.026c.574.754.919 1.692.919 2.713a4.484 4.484 0 1 1-8.969 0c0-1.02.345-1.959.919-2.713zm1.71 16.058h31.573v-2.657H3.629v2.656z",
    clipRule: "evenodd"
  })));
};
export default SvgMultiUnit;